import React from 'react'

function Preloader() {
    return (
        <>
            {/*Preloader starts*/}
            <div className="preloader js-preloader">
                <img src="assets/img/preloader.gif" alt="Image" />
            </div>
            {/*Preloader ends*/}

        </>
    )
}

export default Preloader
